import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "min-h-[100vh] bg-gray-950 flex flex-col md:flex-row md:justify-center"
};
import { ref } from 'vue';
import { useStore } from '@/store';
import { withdrawFee } from '@/wallets';
export default /*#__PURE__*/_defineComponent({
  __name: 'DemoPage',
  setup(__props) {
    const with_draw_fee_runnning = ref(false);
    const store = useStore();
    return (_ctx, _cache) => {
      const _component_LoadingIcon = _resolveComponent("LoadingIcon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = async () => {
          if (_unref(store).activate_wallet) {
            await _unref(withdrawFee)(_unref(store).activate_wallet);
          }
        }),
        class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-1 rounded items-center transition-colors h-full text-lg flex px-2 mt-2 justify-center"
      }, [_createVNode(_component_LoadingIcon, {
        loading: with_draw_fee_runnning.value
      }, {
        default: _withCtx(() => [_createTextVNode(" With Draw Fee ")]),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});